module.exports = __webpack_public_path__ + "img/circle.27a3656.svg";